import type { GroupProperty } from '../common/types.js';

const defaultGroupProperty = (key: string): GroupProperty => ({
  key,
  hide: false,
  manuallyCardSort: [],
});

/**
 * Reorders the requested groups without dropping metadata for groups omitted
 * from the visible projection (for example hidden or hide-empty groups).
 */
export const reorderGroupProperties = (
  existing: GroupProperty[],
  orderedKeys: string[]
): GroupProperty[] => {
  const existingByKey = new Map(existing.map(group => [group.key, group]));
  const requested = new Set(orderedKeys);
  const reordered = orderedKeys.map(
    key => existingByKey.get(key) ?? defaultGroupProperty(key)
  );
  let reorderedIndex = 0;

  const result = existing.map(group => {
    if (!requested.has(group.key)) {
      return group;
    }
    return reordered[reorderedIndex++] ?? group;
  });

  const existingKeys = new Set(existing.map(group => group.key));
  result.push(...reordered.filter(group => !existingKeys.has(group.key)));
  return result;
};
